import type { ChangeEvent, FC } from 'react';
import React from 'react';

import { Segmented, SegmentedGroup } from '@mobiscroll/react';

import { SegmentTabsContainer } from '@shared/ui-kit/tabs/SegmentTabs/SegmentTabs.style';

type SegmentTabsProps = {
  value: string;
  onChange: (event: string) => void;
  config: { label?: string | any; value: string; icon?: any; isDisableSegment?: boolean }[];
  variant?: 'base' | 'dark';
  customHeight?: string;
};
export const SegmentTabs: FC<SegmentTabsProps> = ({
  value,
  onChange,
  config,
  variant = 'base',
  customHeight,
}) => {
  return (
    <SegmentTabsContainer customHeight={customHeight} variant={variant}>
      <SegmentedGroup
        theme={'ios'}
        themeVariant={'light'}
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event?.target.value)}
      >
        {config.map((item, id) => (
          <Segmented
            tabIndex={id}
            key={id}
            icon={item?.icon}
            theme={'ios'}
            themeVariant={'light'}
            value={item.value}
            disabled={item.isDisableSegment}
          >
            {item.label}
          </Segmented>
        ))}
      </SegmentedGroup>
    </SegmentTabsContainer>
  );
};
